@if (dictKeyService.popoverState()) {
<div #popover class="fixed z-[9999]" [style.width.px]="POPOVER_WIDTH" [style.top.px]="posY()" [style.left.px]="posX()">
	<!-- ----- Flèche pointant vers le bas (popover au-dessus de l'élément) -->
	@if (!arrowBelow()) {
	<div
		class="absolute -bottom-[6px] w-3 h-3 bg-white rotate-45 border-r border-b border-gray-200"
		[style.left.px]="arrowLeft() - 6"></div>
	}

	<!-- ----- Flèche pointant vers le haut (popover en-dessous de l'élément) -->
	@if (arrowBelow()) {
	<div class="absolute -top-[6px] w-3 h-3 bg-white rotate-45 border-l border-t border-gray-200" [style.left.px]="arrowLeft() - 6"></div>
	}

	<!-- ----- Panneau principal -->
	<div class="bg-white rounded-lg shadow-xl border border-gray-200 flex flex-col overflow-hidden">
		<!-- ----- Header -->
		<div class="flex items-center justify-between px-3 py-2 bg-gray-50 border-b border-gray-200">
			<span class="text-xs font-mono font-semibold text-indigo-600">{{ dictKeyService.popoverState()!.field }}</span>
			<button
				class="w-5 h-5 flex items-center justify-center rounded hover:bg-gray-200 text-gray-400 hover:text-gray-600 transition-colors"
				(click)="close()">
				<i class="pi pi-times text-xs"></i>
			</button>
		</div>

		@if (loading()) {
		<div class="flex items-center justify-center h-32">
			<ui-loading type="component" size="small" />
		</div>
		} @else {
		<div class="flex flex-col gap-3 p-3">
			<div class="flex flex-col gap-1">
				<label class="text-xs font-medium text-gray-500">fr</label>
				<input pInputText [(ngModel)]="entry.fr" pSize="small" fluid />
			</div>

			<div class="flex flex-col gap-1">
				<label class="text-xs font-medium text-gray-500">en</label>
				<input pInputText [(ngModel)]="entry.en" pSize="small" fluid />
			</div>

			<div class="flex flex-row items-center gap-2">
				<p-checkbox [(ngModel)]="entry.shared" [binary]="true" inputId="dk-shared" />
				<label for="dk-shared" class="text-xs text-gray-500">shared</label>
			</div>
		</div>

		<!-- ----- Footer -->
		<div class="flex justify-end gap-2 px-3 py-2 border-t border-gray-100">
			<p-button
				[label]="Dic.save.text"
				icon="pi pi-save"
				severity="success"
				size="small"
				[loading]="saving()"
				(onClick)="onSave()" />
		</div>
		}
	</div>
</div>
}
